export const getFileNameBySourceUrl = (url: string) => {
  return url.split('/').at(-1) ?? '';
};
